<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform" size="large">
      <zj-layout-container class="content video-monitor">
        <div class="leftNav">
          <div class="leftNav_title">LED屏列表</div>
          <el-input placeholder="搜索LED屏" class="nav-tree-filter" v-model="filterText"></el-input>
          <div class="nav-tree-content">
            <el-tree
              default-expand-all="true"
              style="height:100%;"
              v-loading="loading"
              show-checkbox
              :element-loading-text="loadingText"
              :data="nodes"
              node-key="ID"
              :props="defaultProps"
              :filter-node-method="filterNode"
              class="zj-demo-player-tree-device-tree"
              ref="Ledtree"
            ></el-tree>
          </div>
        </div>
        <!-- 右侧内容 -->
        <div class="rightContent">
          <div class="topContent">信息</div>
          <div style="padding-top:20px;padding-right:80px;">
            <el-form-item label="标题" prop="name">
              <el-input v-model="ruleform.name"></el-input>
            </el-form-item>
            <el-form-item label="内容" prop="desc" size="large">
              <el-input
                type="textarea"
                v-model="ruleform.desc"
                size="large"
                style="min-height:60px;"
              ></el-input>
            </el-form-item>
            <el-form-item style="display:flex;justify-content:flex-end;" size="large">
              <el-button style="float:right;" type="primary" @click="onSendMsg()">一键发送</el-button>
            </el-form-item>
          </div>
        </div>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
// eslint-disable-next-line no-unused-vars
import $ from "jquery";
export default {
  name: "LedMassMessageView",
  controller: "UI",
  action: "LedMassMessageView",
  components: {},
  data() {
    return {
      filterText: "",
      loading: false,
      loadingText: "",
      nodes: [],
      regions: [],
      ruleform: {
        name: "",
        desc: "",
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        desc: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
    };
  },
  watch: {
    filterText(val) {
      this.$refs.Ledtree.filter(val);
    },
  },
  created() {
    this.search();
  },
  mounted() {
    this.logInfo.ActionName = "LED信息群发查询";
    this.logInfo.LogMessage = "LED信息群发查询";
    this.logInfo.ModuleName = "LED系统";
    this.logInfo.PageName = "LED信息群发";
    this.addOperationLog();
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    onSendMsg() {
      var checkNodes = this.$refs.Ledtree.getCheckedNodes(true, false);
      console.log(checkNodes);
      if (checkNodes.length > 0) {
        this.$refs.ruleform.validate((valid) => {
          if (valid) {
            console.log("ok",this.ruleform);
            const ids = checkNodes.map(item=>item.LedInfo.LedIndexNO)
            new MyApis.SendLogApi()
            .SendLog({
                LedIndexNO:ids.join(),
                Title:this.ruleform.name,
                Content:this.ruleform.desc,
                CreateTime: new Date(),
                Creater: ZJApp.ZJUser.current.UserName,
                ModifiyTime: new Date(),
                Modifier: ZJApp.ZJUser.current.UserName,
                Validity: 1,
                Extends1: "",
                Extends2: "",
                Extends3: 0.0,
            })
            .then(r=>{
              console.log(r);
              if(r.RspCode == '1'){
                this.$message.success('提交成功')
                this.$refs.ruleform.resetFields()
              }
            },(e)=>{
              if(e.RspCode == '0'){
                this.$message.success('提交失败')
                this.$refs.ruleform.resetFields()
              }
            })
          } else {
            return false;
          }
        });
      }
      else{
        this.errmsg("请选择LED设备");
      }
    },
    search() {
      let that = this;
      new MyApis.TranResourcesApi()
        .GetLedEquipmentList({})
        .then((r) => {
          r = r.data.Data;
          this.nodes = that.convertToTreeNodesfunction(r);
        })
        .catch((e) => {
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
            type: "error",
          });
        });
    },
    convertToTreeNodesfunction(list) {
      var result = [];
      for (let i = 0; i < list.length; i++) {
        var regionData = list[i];
        var region = {
          ID: regionData.ID,
          label: regionData.NAME_EQT,
          LedInfo: regionData,
        };
        result.push(region);
      }
      let arr = [
        {
          ID: 0,
          label: "LED屏列表",
          children: result,
        },
      ];
      return arr;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
  },
};
</script>

<style scoped>
.leftNav {
  border-right: 1px solid;
  /* border-color:rgba(42, 193,255,0.5); */
  padding: 10px 40px;
  position: relative;
  /* background:#003669; */
  width: 240px;
  height: 99%;
  display: flex;
  flex-direction: column;
  margin-right: 30px;
  box-sizing: border-box;
  overflow: auto;
}
.leftNav_title {
  font-size: 22px;
  font-weight: bold;
  border-bottom: 1px dashed #0ec0fe;
  color: #00bcfe;
  height: 40px;
  position: relative;
}
.nav-tree-filter {
  border-radius: 6px;
  border: solid 1px #00bcfe;
  margin-top: 45px;
  margin-bottom: 20px;
}
/* 右侧内容显示 */
.rightContent {
  flex: 1;
  padding-right: 60px;
  box-sizing: border-box;
}
.topContent {
  padding-top: 20px;
  line-height: 28px;
  font-size: 16px;
  border-bottom: 1px dashed #28bbff;
  color: #28bbff;
}
</style>
